export default function scroll() {
    window.TrazanLeni = false;
    if( document.querySelector('body').classList.contains('elementor-editor-active') ) {
        return;
    }
    
    let enableSmoothScroll = true;
    if ( typeof trazanOptions !== 'undefined' && trazanOptions.enableSmoothScroll !== undefined ) {
        const value = trazanOptions.enableSmoothScroll;
        enableSmoothScroll = value === true || value === 1 || value === '1' || value === 'true';
    }
    
    let smoothScrollLerp = 0.1;
    if ( typeof trazanOptions !== 'undefined' && trazanOptions.smoothScrollLerp !== undefined ) {
        const lerpValue = parseFloat( trazanOptions.smoothScrollLerp );
        if ( !isNaN( lerpValue ) && lerpValue > 0 && lerpValue <= 1 ) {
            smoothScrollLerp = lerpValue;
        }
    }
    
    window.TrazanLenis = new Lenis({
        autoRaf: true,
        smooth: enableSmoothScroll,
        lerp: smoothScrollLerp,
    });
}